export default __webpack_public_path__ + "static/media/7magic.9512782d.mp3";